import { axios_oauth as axios, axios as api_axios, AxiosResponse } from '@/plugins/axios';

import { SendOtpPayload, CheckOtpPayload } from './types';

export function sendOtp(payload: SendOtpPayload): Promise<AxiosResponse> {
	return api_axios.post('/api/students/send_otp', payload);
}

export function checkOtp(payload: CheckOtpPayload): Promise<AxiosResponse> {
	return axios.post('/api/otps/check', payload);
}
